export default __webpack_public_path__ + "static/media/StepBg3.9049b4d4.svg";